export const environment = {
  production: true,
  host: process.env['BACKEND_URL'],
  host_tiktok: process.env['BACKEND_URL_TIKTOK'],
  authHost: process.env['AUTH_URL'],
  videoHost: process.env['VIDEO_URL'],
  amplitudeApiKey: process.env['AMPLITUDE_API_KEY'],
  toolName: process.env['TOOL_NAME'],
  branchName: process.env['CI_COMMIT_REF_NAME'],
  sentry_dsn: process.env['SENTRY_DSN'],
  aitarget_domain: process.env['AITARGET_DOMAIN'],
  aitarget_subdomain: process.env['AITARGET_SUBDOMAIN'],
  google_recaptcha_site_key: process.env['GOOGLE_RECAPTCHA_SITE_KEY'],
  youtubeTutorVideoRu: process.env['YOUTUBE_TUTOR_VIDEO_RU'],
  youtubeTutorVideoEn: process.env['YOUTUBE_TUTOR_VIDEO_EN'],
  gtmId: process.env['GTM_ID'],
  facebookPixelId: process.env['FACEBOOK_PIXEL_ID'],
  sentry_enabled: false,
  sentry_environment: 'development',
  ipGeoLocationKey: process.env['IP_GEO_LOCATION_KEY'],
  callTouchCounterId: process.env['CALL_TOUCH_COUNTER_ID'],
  redirectEnabled: process.env['REDIRECT_ENABLED']?.toLowerCase() === 'true',
  redirectUrl: process.env['REDIRECT_URL']
};
